export { default } from "./ClaimedDealHDPMessage";
